export default {"src":"/_next/static/media/whyPodIcon.b942b59f.svg","height":101,"width":104};